<template>
  <transition name="fade">
    <div class="c-messagebox__layer" ref="dom" v-show="visible" data-layer>
      <transition name="slidedown">
        <div class="c-messagebox" v-show="visible">
          <div class="c-messagebox__header">{{ title }}</div>
          <div class="c-messagebox__content">
            <div v-show="messageType == 'text'">{{ message }}</div>
            <div v-show="messageType == 'input'">
              <input
                type="text"
                class="c-messagebox__input"
                v-model="inputVal"
                v-focus="200"
                v-select="200"
                @keydown.enter="confirmHandle"
                maxlength="50"
                :placeholder="inputPlaceholder"
              />
            </div>
          </div>
          <div class="c-messagebox__btnw">
            <div
              class="c-messagebox__sure"
              :class="[
                messageType == 'input' && !canSubmit
                  ? 'c-messagebox__sure--disable'
                  : '',
                confirmBtnClass,
                type == 'vip' ? 'c-messagebox__btn--vip' : ''
              ]"
              :style="confirmBtnStyle"
              @click="confirmHandle"
            >
              {{ confirmBtnText }}
            </div>
            <div
              class="c-messagebox__cancel"
              :style="cancelBtnStyle"
              @click="cancelHandle"
              v-show="!hideCancelBtn"
            >
              {{ cancelBtnText }}
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import lang from '@/i18n/locale.js';
export default {
  mounted() {
    this.visible = true;
    let hashHandler = () => {
      this.cancelHandle();
    };
    let keydownHandler = (e) => {
      if (e.keyCode == 27) {
        this.cancelHandle();
      } else if (e.keyCode == 13 && this.messageType != 'input') {
        this.confirmHandle();
      }
    };
    window.addEventListener('hashchange', hashHandler, false);
    window.addEventListener('keydown', keydownHandler, false);
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('hashchange', hashHandler, false);
      window.removeEventListener('keydown', keydownHandler, false);
    });
  },
  data() {
    return {
      title: '',
      type: '',
      messageType: 'text',
      message: '',
      inputVal: '',
      inputPlaceholder: '',
      cancelBtnText: lang['cancel'],
      confirmBtnText: lang['sure'],
      confirmBtnStyle: {},
      cancelBtnStyle: {},
      confirmBtnClass: '',
      confirm: () => {},
      cancel: () => {},
      hideCancelBtn: false,
      visible: false
    };
  },
  computed: {
    canSubmit() {
      return this.messageType == 'text' || this.inputVal.trim();
    }
  },
  methods: {
    confirmHandle() {
      if (this.canSubmit) {
        this.confirm(this.inputVal);
        this.close().then(() => {
          this.$refs.dom.remove();
          this.$destroy();
        });
      }
    },
    cancelHandle() {
      this.cancel();
      this.close().then(() => {
        this.$refs.dom.remove();
        this.$destroy();
      });
    },
    close() {
      return new Promise((resolve, reject) => {
        this.visible = false;
        setTimeout(() => {
          resolve();
        }, 300);
      });
    }
  }
};
</script>

<style lang="scss">
@import '@a/scss/mixin.scss';
.c-messagebox__layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
}
.c-messagebox {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
  width: 400px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.18);
  @include clearfix;
}
.c-messagebox__header {
  height: 40px;
  line-height: 40px;
  padding-left: 24px;
  background-color: #fafafa;
  border-radius: 4px 4px 0 0;
}
.c-messagebox__content {
  padding: 20px 24px;
}
.c-messagebox__btnw {
  overflow: hidden;
  margin-bottom: 24px;
  text-align: center;
  padding: 0 24px;
}
.c-messagebox__sure {
  float: right;
  padding: 0 22px;
  height: 32px;
  line-height: 30px;
  @include g-btn-green;
  margin-left: 20px;
}
.c-messagebox__sure--disable {
  @include g-btn-green--disable;
}

.c-messagebox__cancel {
  cursor: pointer;
  float: right;
  padding: 0 22px;
  height: 32px;
  line-height: 30px;
  border-radius: 4px;
  border: 1px solid rgba(171, 171, 171, 1);
  &:hover {
    border: 1px solid #222;
  }
}
.c-messagebox__input {
  display: block;
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 14px;
  background: rgba(250, 250, 250, 1);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  border: 1px solid rgba(216, 216, 216, 1);
}
.c-messagebox__btn--vip {
  background: #edd09d;
  color: #6b4606;
  &:hover {
    background: #ebc684;
  }
}

//
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

// 进入时动画的状态  v-enter => v-enter-to
// 离开时动画的状态  v-leave => v-leave-to
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slidedown-enter-active,
.slidedown-leave-active {
  transition: transform 0.3s;
}

.slidedown-enter,
.slidedown-leave-to {
  transform: translate(-50%, -100%);
}
// 如果不设置v-enter-to和v-leave,默认会复原到动画前的状态
.slidedown-enter-to,
.slidedown-leave {
  transform: translate(-50%, -50%);
}
</style>
